/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoPoint } from './GeoPoint';
import {
    GeoPointFromJSON,
    GeoPointFromJSONTyped,
    GeoPointToJSON,
    GeoPointToJSONTyped,
} from './GeoPoint';

/**
 * 
 * @export
 * @interface NewParish
 */
export interface NewParish {
    /**
     * 
     * @type {string}
     * @memberof NewParish
     */
    name?: string;
    /**
     * 
     * @type {GeoPoint}
     * @memberof NewParish
     */
    geo?: GeoPoint;
}

/**
 * Check if a given object implements the NewParish interface.
 */
export function instanceOfNewParish(value: object): value is NewParish {
    return true;
}

export function NewParishFromJSON(json: any): NewParish {
    return NewParishFromJSONTyped(json, false);
}

export function NewParishFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewParish {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'geo': json['geo'] == null ? undefined : GeoPointFromJSON(json['geo']),
    };
}

export function NewParishToJSON(json: any): NewParish {
    return NewParishToJSONTyped(json, false);
}

export function NewParishToJSONTyped(value?: NewParish | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'geo': GeoPointToJSON(value['geo']),
    };
}

